/**
 * Featured Products Block
 *
 * Handles the featured products block functionality.
 */

(() => {
    function registerFeaturedProducts() {
        const featuredProducts = document.querySelectorAll('.product-features__item');

        if (featuredProducts.length === 0) {
            return;
        }

        // Fallback tooltip function using native title attribute
        const createFallbackTooltip = (element, content) => {
            element.setAttribute('title', content);
            element.style.cursor = 'help';
        };

        // Wait for tippy to be available
        const initTippy = () => {
            // Check for different possible tippy global names
            let tippyFunction = null;

            if (typeof window.tippy !== 'undefined') {
                tippyFunction = window.tippy;
            } else if (typeof window.tippyjs !== 'undefined') {
                tippyFunction = window.tippyjs;
            } else if (typeof window.Tippy !== 'undefined') {
                tippyFunction = window.Tippy;
            }

            if (!tippyFunction) {
                // If tippy is not available after 3 seconds, use fallback
                if (window.tippyTimeout) {
                    clearTimeout(window.tippyTimeout);
                }

                window.tippyTimeout = setTimeout(() => {
                    console.warn('Tippy.js not available, using fallback tooltips');
                    featuredProducts.forEach((product) => {
                        const content = product.dataset.tippyContent;
                        if (content) {
                            createFallbackTooltip(product, content);
                        }
                    });
                }, 3000);

                // Try again in 100ms
                setTimeout(initTippy, 100);
                return;
            }

            // Clear any existing timeout
            if (window.tippyTimeout) {
                clearTimeout(window.tippyTimeout);
                window.tippyTimeout = null;
            }

            featuredProducts.forEach((product) => {
                try {
                    const tippyInstance = tippyFunction(product, {
                        content: product.dataset.tippyContent,
                        placement: 'top',
                        arrow: true,
                        theme: 'light-border',
                        allowHTML: true,
                    });
                } catch (error) {
                    console.warn('Failed to initialize tippy for product feature:', error);
                    // Fallback to native tooltip
                    const content = product.dataset.tippyContent;
                    if (content) {
                        createFallbackTooltip(product, content);
                    }
                }
            });
        };

        // Start the initialization process
        initTippy();
    }

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', registerFeaturedProducts);
    } else {
        registerFeaturedProducts();
    }
})();
